// extracted by mini-css-extract-plugin
export var menuIcon = "_p0-0";
export var menuIconInline = "_p0-1";